import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(({ theme }) => ({
  width: 'fit-content',
  maxWidth: '90%',
  display: 'flex',
  alignItems: 'end',
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  whiteSpace: 'pre-wrap',

  [theme.breakpoints.up('sm')]: {
    maxWidth: 'min(500px, 75%)',
  },
}));
